<h2 mat-dialog-title class="dialog-title">
  <mat-icon>manage_accounts</mat-icon>
  <span>Manage Contract Accounts</span>
  <span class="spacer"></span>
  <button mat-raised-button color="primary" (click)="openAddAccountDialog()">
    <mat-icon>add</mat-icon>
    Add Account
  </button>
  <button mat-icon-button (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  @if (loading) {
  <div class="loading-container">
    <mat-spinner diameter="36"></mat-spinner>
  </div>
  } @else {
  <div class="table-container">
    <table mat-table [dataSource]="accounts" class="mat-elevation-z4">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let m">{{ m.name }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let m">{{ m.login_info_email }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let m">
          <div class="status-cell">
            @if (updatingStatusId === m.id) {
            <mat-spinner diameter="20"></mat-spinner>
            } @else {
            <mat-select [value]="m.status" (selectionChange)="onStatusChange(m, $event.value)"
              [disabled]="m.status === 'Locked'" class="status-select">
              @for (s of statusOptions; track s) {
              <mat-option [value]="s">
                <span [class]="'status-badge ' + getStatusClass(s)">{{ s }}</span>
              </mat-option>
              }
            </mat-select>
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="locked_by">
        <th mat-header-cell *matHeaderCellDef>Locked By</th>
        <td mat-cell *matCellDef="let m">
          @if (m.locked_by_contract_id) {
          <span class="contract-id" [matTooltip]="m.locked_by_contract_id">
            {{ m.locked_by_contract_id | slice:0:8 }}…
          </span>
          } @else {
          <span class="empty-value">—</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="created_at">
        <th mat-header-cell *matHeaderCellDef>Created</th>
        <td mat-cell *matCellDef="let m">{{ formatDate(m.created_at) }}</td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let m">
          <div>
            <button mat-icon-button (click)="openEditAccountDialog(m)" matTooltip="Edit">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" (click)="deleteAccount(m)" [disabled]="m.status === 'Locked'"
              [matTooltip]="m.status === 'Locked' ? 'Cannot delete locked account' : 'Delete'">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    @if (accounts.length === 0) {
    <div class="empty-state">No accounts found.</div>
    }
  </div>

  <div class="pagination">
    <button mat-mini-fab (click)="pageChanged(pageIndex - 1)" [disabled]="pageIndex === 0">
      <mat-icon>navigate_before</mat-icon>
    </button>

    <span class="page-info">
      Page
      <input type="number" class="page-input" [value]="pageIndex + 1" (change)="onPageInputChange($event)"
        (keyup.enter)="onPageInputChange($event)" min="1" [max]="totalPages || 1" />
      of {{ totalPages || 1 }} (Total: {{ total }})
    </span>

    <button mat-mini-fab (click)="pageChanged(pageIndex + 1)" [disabled]="pageIndex + 1 >= totalPages">
      <mat-icon>navigate_next</mat-icon>
    </button>
  </div>
  }
</mat-dialog-content>